import { render, staticRenderFns } from "./BackofficeProtocolo.vue?vue&type=template&id=ac3197de&scoped=true"
import script from "./BackofficeProtocolo.vue?vue&type=script&lang=ts"
export * from "./BackofficeProtocolo.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeProtocolo.vue?vue&type=style&index=0&id=ac3197de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac3197de",
  null
  
)

export default component.exports